<template>
    <div>
        <v-dialog v-model="openDialog" persistent>
            <v-card>
                <v-card-title>
                {{ formTitle }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                <v-container>
                <ValidationObserver ref="observer">
                    <form>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <ValidationProvider v-slot="{ errors }" name="Tipo" rules="required">
                            <v-select :no-data-text="noDataAvailable" label="Tipo" v-model="frmItem.type"
                              :items="allTypes" item-text="description" item-value="code" :error-messages="errors" required>
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <ValidationProvider v-slot="{ errors }" name="Code" rules="required">
                            <v-text-field label="Code" v-model="frmItem.credentialCode"
                                          prepend-icon="mdi-card-text" required :error-messages="errors"></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <ValidationProvider v-slot="{ errors }" name="Nome" rules="required|max:255">
                            <v-text-field label="Nome" v-model="frmItem.name"
                                          prepend-icon="mdi-account" required :error-messages="errors"></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <ValidationProvider v-slot="{ errors }" name="Descrição" rules="required|max:255">
                            <v-text-field label="Descrição" v-model="frmItem.description"
                                          prepend-icon="mdi-account" required :error-messages="errors"></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <ValidationProvider v-slot="{ errors }" prepend-icon="mdi-protocol"  name="Protocol" rules="required">
                                <v-select :no-data-text="noDataAvailable" label="Protocol" v-model="frmItem.protocol"
                                    :items="allProtocols" :error-messages="errors" required>
                                </v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <ValidationProvider v-slot="{ errors }" name="Share" rules="required|max:255">
                                <v-text-field label="Share" v-model="frmItem.share"
                                prepend-icon="mdi-folder" required :error-messages="errors"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <ValidationProvider v-slot="{ errors }" name="Diretorio" rules="required|max:255">
                            <v-text-field label="Diretorio" v-model="frmItem.initDirectory"
                                          prepend-icon="mdi-account" required :error-messages="errors"></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <ValidationProvider v-slot="{ errors }" name="Account Name" rules="required|max:255">
                                <v-text-field label="Account Name" v-model="frmItem.accountName"
                                prepend-icon="mdi-account" required :error-messages="errors"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <ValidationProvider v-slot="{ errors }" name="Account Key" rules="required|max:255">
                                <v-text-field label="Account Key" v-model="frmItem.accountKey"
                                prepend-icon="mdi-account-key" required :error-messages="errors"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <header>Ativa</header>
                          <v-switch v-model="frmItem.active"></v-switch>
                        </v-col>
                      </v-row>
                    </form>
                </ValidationObserver>
                </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="buttonTextColor" text @click="close">Cancelar</v-btn>
                    <v-btn color="buttonTextColor" text @click="save">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { required, max } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} não pode ser vazio',
});

extend('max', {
  ...max,
  message: '{_field_} não pode ter mais do que {length} characteres',
});

export default {
  name: 'DialogItem',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    open: Boolean,
    editedItem: {},
    editing: Boolean,
  },

  data: () => ({
    isLoadingContent: false,
    dialogSearch: false,
    searchDialogSearch: '',
    selectedDialogSearch: [],
    headersSearch: [
      { text: 'Descrição', value: 'description' },
    ],
    defaultItem: {
      description: '',
      path: '',
      permission: true,
    },
    frmItem: {},
    openDialog: false,
    allTypes: [{ description: 'Azure', code: 'AZURE' }],
    allProtocols: ['http', 'https'],
    noDataAvailable: 'Nenhum dado encontrado',
  }),

  computed: {
    formTitle() {
      return !this.editing ? 'Nova credencial' : 'Editar credencial';
    },
  },

  watch: {
    open() {
      this.openDialog = this.open;
    },
    editedItem() {
      this.frmItem = { ...this.editedItem };
    },
  },

  methods: {
    clearRuleConfigs() {
      this.frmItem.ruleConfigs = [];
    },

    close() {
      this.isLoadingContent = false;
      this.$refs.observer.reset();
      this.$emit('closeDialogItem');
    },

    save() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.$emit('saveDialogItem', this.frmItem);
          this.$refs.observer.reset();
        }
      });
    },

    btnCancelDialogSearch() {
      this.selectedDialogSearch = [];
      this.dialogSearch = false;
    },

    btnSelectDialogSearch() {
      if (!this.frmItem.ruleConfigs) {
        this.frmItem.ruleConfigs = [];
      }
      if (this.selectedDialogSearch && this.selectedDialogSearch.length && this.selectedDialogSearch.length > 0) {
        const self = this;
        this.selectedDialogSearch.forEach((el) => {
          if (!self.frmItem.ruleConfigs.find((rc) => rc.idEntityTypeRule === el.id)) {
            self.frmItem.ruleConfigs.push({
              idEntityTypeRule: el.id,
            });
          }
        });
      }

      this.dialogSearch = false;
      this.selectedDialogSearch = [];
    },
  },
};
</script>
